module.exports = __webpack_public_path__ + "img/cross.3dfa4ad1.svg";